import React from 'react';

function NotFoundSceneView() {
  return (
    <p>Not Found.</p>
  );
}

export default NotFoundSceneView;
